/**
 * Whether the visitor is in the United States. The single gate for US-only
 * surfaces (e.g. the Elections nav entry) so wiring the real signal later is a
 * one-file change.
 *
 * @returns {boolean}
 */
// TODO: wire to Cloud CDN region header (returns true for everyone until then).
export const useIsUsRegion = () => true;
